// hooks/useSearchApi.js
import { useState } from 'react';
import axios from 'axios';

const useSearchApi = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchCreators = async ({ page = 1, platforms = [], categories = [], keywords = [""] }) => {
        setLoading(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_BASE_URL + `/api/search?page=${page}`,
                { platforms, categories, keywords },
                { headers: { 'Content-Type': 'application/json' } }
            );
            setData(response.data.data);
            setMeta(response.data.meta);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return { data, meta, loading, error, fetchCreators };
};

export default useSearchApi;
